module.exports = __webpack_public_path__ + "img/local piscine.f1e2d821.jpg";